module.exports = __webpack_public_path__ + "static/media/travel-logo.f8484913.jpg";